export default () => ({
  show: false,
  isLoading: true,
  onCancel: false,
  fullPage: true,
  garages: [],
  bike: {
    tower_id: null,
    unit_id: null,
    status: true,
    rack: null,
    garege_id: null
  },
  bikes: [],
  entity: 'bike',
  entities: 'bikes',
  dwellerUnits: [],
  dwellerTowers: [],
  optionStatus: [
    {
      id: true,
      label: 'Ativo'
    },
    {
      id: false,
      label: 'Inativo'
    }
  ],
  prefixRouter: 'tenant.bike'
})



// WEBPACK FOOTER //
// ./src/app/tenant/bike/resources/data.js